module.exports = __webpack_public_path__ + "static/media/House.5cef6ddb.svg";